// i18n namespace "footer" (WP-A). One-line descriptor from the hero positioning.

export const en = {
  description: "Senior SAP teams for companies in Mexico and the Americas.",
  servicesTitle: "Services",
  serviceFinance: "SAP Finance and e-invoicing",
  serviceLogistics: "SAP Logistics and EWM",
  serviceAi: "AI assistants on SAP",
  companyTitle: "Company",
  team: "Team",
  approach: "How we work",
  careers: "Careers",
  faq: "FAQ",
  contactTitle: "Contact",
  careersEmail: "Careers",
  signIn: "Staff sign in",
  legalAriaLabel: "Legal",
  copyright: "© {{year}} DuxTrans. All rights reserved.",
  privacy: "Privacy",
  terms: "Terms",
};

export const es = {
  description: "Equipos SAP senior para empresas en México y las Américas.",
  servicesTitle: "Servicios",
  serviceFinance: "SAP Finanzas y facturación electrónica",
  serviceLogistics: "SAP Logística y EWM",
  serviceAi: "Asistentes de IA en SAP",
  companyTitle: "Empresa",
  team: "Equipo",
  approach: "Cómo trabajamos",
  careers: "Vacantes",
  faq: "Preguntas frecuentes",
  contactTitle: "Contacto",
  careersEmail: "Vacantes",
  signIn: "Acceso del equipo",
  legalAriaLabel: "Información legal",
  copyright: "© {{year}} DuxTrans. Todos los derechos reservados.",
  privacy: "Privacidad",
  terms: "Términos",
};

export const fr = {
  description: "Des équipes SAP seniors pour les entreprises au Mexique et dans les Amériques.",
  servicesTitle: "Services",
  serviceFinance: "SAP Finance et facturation électronique",
  serviceLogistics: "SAP Logistique et EWM",
  serviceAi: "Assistants IA sur SAP",
  companyTitle: "Entreprise",
  team: "Équipe",
  approach: "Notre méthode",
  careers: "Carrières",
  faq: "FAQ",
  contactTitle: "Contact",
  careersEmail: "Carrières",
  signIn: "Accès équipe",
  legalAriaLabel: "Mentions légales",
  copyright: "© {{year}} DuxTrans. Tous droits réservés.",
  privacy: "Confidentialité",
  terms: "Conditions",
};

export const pt = {
  description: "Equipes SAP sênior para empresas no México e nas Américas.",
  servicesTitle: "Serviços",
  serviceFinance: "SAP Finanças e faturamento eletrônico",
  serviceLogistics: "SAP Logística e EWM",
  serviceAi: "Assistentes de IA no SAP",
  companyTitle: "Empresa",
  team: "Equipe",
  approach: "Como trabalhamos",
  careers: "Vagas",
  faq: "Perguntas frequentes",
  contactTitle: "Contato",
  careersEmail: "Vagas",
  signIn: "Acesso da equipe",
  legalAriaLabel: "Informações legais",
  copyright: "© {{year}} DuxTrans. Todos os direitos reservados.",
  privacy: "Privacidade",
  terms: "Termos",
};
